"use client";
import Link from "next/link";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { useTranslations } from "next-intl";

export const VerifyEmailHeader = () => {
  const t = useTranslations("VerifyEmailHeader");
  return (
    <div
      data-testid={applyDataTestId(pom.verifyEmail.verifyEmailHeader)}
      className={[
        "flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link href="/customer-profile">
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <span className="text-[20px] font-medium text-[#373737]">
              {t("account")}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};
